import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { InitAuthService } from '@app/services/global-services/auth/init-auth-service';

export const IsAnonymousGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const initAuthService: InitAuthService = inject(InitAuthService);

  const router: Router = inject(Router);

  return initAuthService.isAuthenticated().pipe(
    switchMap((isAuthenticated: boolean) => {
      if (isAuthenticated) {
        router.navigateByUrl('/').then();
        return of(false);
      } else {
        return of(true);
      }
    }),
  );
};
